import React from 'react'
import AppSubmitModal from '../AppSubmitModal'
import animationSrc from './animation.mp4'

const AppPublishedModal = ({ onCloseInitiated }) => (
  <AppSubmitModal
    title="Thumbs Up!"
    animationSrc={animationSrc}
    description="Congrats on publishing your app to the Drift App Directory! It’s now out in the wild where others can enjoy what you’ve built. Two thumbs way up!"
    onCloseInitiated={onCloseInitiated}
  />
)

export default AppPublishedModal
